module.exports = __webpack_public_path__ + "static/media/poll-card-icon.9050ac7b.svg";